import { render } from "./PrintHeaderDesign4.vue?vue&type=template&id=c5d92c8a&scoped=true"
import script from "./PrintHeaderDesign4.vue?vue&type=script&lang=js"
export * from "./PrintHeaderDesign4.vue?vue&type=script&lang=js"

import "./PrintHeaderDesign4.vue?vue&type=style&index=0&id=c5d92c8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5d92c8a"]])

export default __exports__